import React from 'react'

import { PartnersType } from '@contracts/Components/Partners'

import * as styles from './PartnersGrid.module.scss'
import PartnersGridItem from './PartnersGridItem'

interface Props {
	partners: PartnersType[]
	type: 'small' | 'default'
}

const PartnersGrid = (props: Props) => {
	const gridStyles = [styles.grid]

	if (props.type === 'small') {
		gridStyles.push(styles.small)
	}

	return (
		<ul className={gridStyles.join(' ')}>
			{props.partners.map(({ partner }) => {
				return <PartnersGridItem key={partner.id} partner={partner} />
			})}
		</ul>
	)
}

PartnersGrid.defaultProps = {
	type: 'default',
}

export default PartnersGrid
